// Clipboard write, extracted from email-copy.ts so the document renderer can
// use it without importing that module: email-copy.ts imports DocHtml.tsx, so
// a copy field inside DocHtml reaching back for copyPlainText would close an
// import cycle. email-copy.ts re-exports this, so every existing call site is
// unchanged.

// Clipboard write with a textarea fallback for engines without the async
// clipboard API (or without permission). Returns success honestly.
export async function copyPlainText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch { /* fall through to the legacy path */ }
  try {
    const area = document.createElement("textarea");
    area.value = text;
    area.setAttribute("readonly", "");
    area.style.position = "fixed";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();
    const copied = document.execCommand("copy");
    area.remove();
    return copied;
  } catch {
    return false;
  }
}
